import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable, map } from 'rxjs'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { AppState } from 'src/app/store/state/app.state'
import { Store } from '@ngrx/store'
import { EntityWiseDataAPIModel, UserDashboardAPIModel } from '../../models/api.model'
import {
  delete_entity_wise_data_action,
  load_dashboard_action,
  load_entity_wise_data_action
} from 'src/app/store/action/dashboard.action'
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private webService: WebService, private appState: Store<AppState>) {}

  getUserDashboard(from: Date, to: Date): Observable<UserDashboardAPIModel> {
    return this.webService
      .post(ServiceUrlConstants.API_DASHBOARD, { begin: from, end: to })
      .pipe(map((data: any) => data))
  }

  getEmpDashboardSelect(): Observable<any> {
    return this.appState.select('dashboard')
  }

  getEntityWiseDataSelect(): Observable<EntityWiseDataAPIModel> {
    return this.appState.select('entityWiseData')
  }

  dispatchDashboardLoadAction(from: Date, to: Date) {
    this.appState.dispatch(load_dashboard_action({ from, to }))
  }

  dispatchEntityWiseDataLoadAction(companyEntities: string[], from: Date, to: Date) {
    this.appState.dispatch(load_entity_wise_data_action({ companyEntities, from, to }))
  }

  dispatchDeleteEntityWiseDataLoadAction() {
    this.appState.dispatch(delete_entity_wise_data_action())
  }

  getEntityWiseData(companyEntities: string[], from: Date, to: Date): Observable<EntityWiseDataAPIModel> {
    return this.webService
      .post(ServiceUrlConstants.API_ENTITY_WISE_DATA, {
        companyEntityIds: companyEntities,
        dateRange: { begin: from, end: to }
      })
      .pipe(map((data: any) => data))
  }
}
